import { toast } from 'react-toastify'
import apiService from 'services/api'
import { CompanyGPO } from 'models/companies'
import { GPOsCell } from 'components/FbUI/StagePill'
import { MobileAssignModal } from './MobileAssignModal'
import { ManageTagsDistributorsParams } from 'services/common_table_actions'

interface MobileGPOAssignModalProps {
  isOpen: boolean
  onClose: () => void
  contactCompanyId: number
  doorProxyId?: number
  isDoorPage?: boolean
  onSuccess?: () => void
}

export function MobileGPOAssignModal({
  isOpen,
  onClose,
  contactCompanyId,
  doorProxyId,
  isDoorPage = false,
  onSuccess,
}: MobileGPOAssignModalProps) {
  const api = apiService()
  const { data: gpos, refetch: refetchGPOs } = api.useGetGPOs()

  const handleCreateGPO = async (value: string): Promise<CompanyGPO | null> => {
    if (value.length > 50) {
      toast.error('GPO name length limited to 50 characters.')
      return null
    }
    return (await api.postGPO?.({ name: value })) ?? null
  }

  const apiAction = async (params: ManageTagsDistributorsParams) => {
    const modifiedParams = {
      ...params,
      include_ids: isDoorPage ? [doorProxyId!] : [contactCompanyId],
      exclude_ids: [],
      filter_params: {},
    }
    return api.commonManageGPOs?.({
      values: modifiedParams,
      tableType: isDoorPage ? 'restaurants-bars-doors' : 'companies-table',
    })
  }

  const getSortValue = (
    gpo: CompanyGPO,
    sortBy: string
  ): string | number | Date => {
    switch (sortBy) {
      case 'name':
        return gpo.name.toLowerCase()
      default:
        return gpo.name.toLowerCase()
    }
  }

  return (
    <MobileAssignModal<CompanyGPO>
      isOpen={isOpen}
      onClose={onClose}
      title="Assign GPOs"
      subtitle="Select GPOs to apply or remove."
      items={gpos || []}
      renderItem={(gpo) => <GPOsCell gpos={[gpo]} maxBadges={1} />}
      countHeader="Usage"
      apiAction={apiAction}
      itemListKey="gpo_ids"
      onSuccess={onSuccess}
      refetchFn={refetchGPOs}
      onCreateNew={handleCreateGPO}
      createNewLabel="Create GPO"
      createNewPlaceholder="New GPO name"
      getSortValue={getSortValue}
      assignType="gpos"
    />
  )
}
